// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-empty-state {
  display: grid;
  justify-items: center;
  gap: var(--admin-s3);
  padding: var(--admin-s8) var(--admin-s5);
  text-align: center;
}

.au-empty-state__icon {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border: var(--admin-border-subtle);
  border-radius: var(--admin-radius-lg);
  color: var(--admin-text-muted);
}

.au-empty-state__icon svg {
  width: 28px;
  height: 28px;
  stroke: currentColor;
  stroke-width: 1px;
}

.au-empty-state__title {
  margin: 0;
  color: var(--admin-text-primary);
  font-size: var(--admin-text-md);
  font-weight: var(--admin-font-weight-semibold);
}

.au-empty-state__body {
  max-width: 320px;
  margin: 0;
  color: var(--admin-text-secondary);
  font-size: var(--admin-text-sm);
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminEmptyState.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".au-empty-state {\n  display: grid;\n  justify-items: center;\n  gap: var(--admin-s3);\n  padding: var(--admin-s8) var(--admin-s5);\n  text-align: center;\n}\n\n.au-empty-state__icon {\n  display: grid;\n  place-items: center;\n  width: 64px;\n  height: 64px;\n  border: var(--admin-border-subtle);\n  border-radius: var(--admin-radius-lg);\n  color: var(--admin-text-muted);\n}\n\n.au-empty-state__icon svg {\n  width: 28px;\n  height: 28px;\n  stroke: currentColor;\n  stroke-width: 1px;\n}\n\n.au-empty-state__title {\n  margin: 0;\n  color: var(--admin-text-primary);\n  font-size: var(--admin-text-md);\n  font-weight: var(--admin-font-weight-semibold);\n}\n\n.au-empty-state__body {\n  max-width: 320px;\n  margin: 0;\n  color: var(--admin-text-secondary);\n  font-size: var(--admin-text-sm);\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
